import EventEmitter from 'eventemitter3';

const Emitter = new EventEmitter();
export default Emitter;
